/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungChecklisteDto } from '../../models/lexplus-anforderung-checkliste-dto';
import { LexplusUpdateAnforderungChecklisteAnswerDto } from '../../models/lexplus-update-anforderung-checkliste-answer-dto';

export interface AnforderungDetailControllerUpdateAnforderungChecklisteAnswerV1$Params {
  anforderungsversionID: number;
  checklistQuestionID: number;
      body: LexplusUpdateAnforderungChecklisteAnswerDto
}

export function anforderungDetailControllerUpdateAnforderungChecklisteAnswerV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerUpdateAnforderungChecklisteAnswerV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungChecklisteDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerUpdateAnforderungChecklisteAnswerV1.PATH, 'patch');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.path('checklistQuestionID', params.checklistQuestionID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungChecklisteDto>;
    })
  );
}

anforderungDetailControllerUpdateAnforderungChecklisteAnswerV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/checkliste/fragen/{checklistQuestionID}/antwort';
